import { render, staticRenderFns } from "./tiku.vue?vue&type=template&id=d502f2b8&scoped=true&"
import script from "./tiku.vue?vue&type=script&lang=js&"
export * from "./tiku.vue?vue&type=script&lang=js&"
import style0 from "./tiku.vue?vue&type=style&index=0&id=d502f2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d502f2b8",
  null
  
)

export default component.exports